import styled from 'styled-components';
import { Grid } from '@lifechurch/react-ion';

export const ClickableTableRow = styled(Grid)`
  margin-inline-start: -8px;
  padding-top: 3px;
  padding-inline-end: 0;
  padding-inline-start: 8px;
  align-items: center;
  grid-template-columns: 60px 1fr 120px 100px 80px 20px;
  grid-column-gap: 1rem;
  position: relative;
  cursor: pointer;

  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  p:not(:first-of-type) {
    color: ${props => props.theme.colors.gray80};
  }

  div&:hover {
    background-color: ${props => props.theme.colors.action.light};
    & > p,
    div svg path {
      color: ${props => props.theme.colors.gray100};
      fill: ${props => props.theme.colors.gray100};
    }

    & > p:nth-child(1) {
      color: ${props => props.theme.colors.action.hover};
      fill: ${props => props.theme.colors.action.hover};
    }

    &:after {
      display: none;
    }

    &:not(:first-child) {
      box-shadow: 0px -1px ${props => props.theme.colors.action.light};
    }
  }
`;
